/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}

// prevent card link from firing when interacting with variant select
document.querySelectorAll('a.collectionItem').forEach(card => {
    card.addEventListener('click', function (e) {
        if (e.target.closest('.collectionItemVariationSelect')) {
            e.preventDefault();
        }
    });
});

// variant updates on collection cards
document.querySelectorAll('.collectionItemVariationSelect')?.forEach(select => {
    select.addEventListener('change', function () {

        const parent = this.closest('.collectionItem');
        const selected = this.options[this.selectedIndex];

        // update price
        if (parent.querySelector('.collectionItemButtonPrice')) {
            parent.querySelector('.collectionItemButtonPrice').textContent = `${price(selected.dataset.price)}`;
        }
        // update availability on button
        const itemButton = parent.querySelector('.collectionItemButtonAtc') || null;
        if (itemButton) {
            if (selected.dataset.text !== "") {
                itemButton.textContent = selected.dataset.text;
            } else {
                if (selected.dataset.available === 'true') {
                    itemButton.textContent = "ADD TO CART";
                    itemButton.disabled = false;
                } else {
                    itemButton.textContent = "SOLD OUT";
                    itemButton.disabled = true;
                }
            }
        }

        // update image on multi variant products
        parent.querySelector('.collectionImage.active')?.classList.remove('active');
        parent.querySelector(`.collectionImage[data-id="${this.value}"]`)?.classList.add('active');
    })
})

// add to cart functionality
document.querySelectorAll('.collectionItemButtonAtc')?.forEach(card => {
    card.addEventListener('click', async function (e) {
        // card is a link
        e.preventDefault();

        // add loading animation to both buttons
        this.classList.add("loading");

        let variantId;
        if (this.classList.contains('singleVariant')) {
            variantId = parseInt(this.dataset.id);
        } else {
            variantId = parseInt(this.closest('.collectionItem').querySelector('.collectionItemVariationSelect').value);
        }

        // see if the selected variant is a pre-order item
        const properties = {};
        const selectedOption = this.closest('.collectionItem').querySelector('.collectionItemVariationSelect')?.selectedOptions[0];
        if (selectedOption?.dataset?.message) {
            properties.Preorder = selectedOption.dataset.message;
        }

        let formData = {
            items: [{
                quantity: 1,
                id: variantId,
                properties: properties
            }]
        };

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    })
})

// function to redirect based on state if on PDP
function redirectChecker(userSelectedState) {
    /*
    bottle type is different
    Safety bottle : /products/1777-thc-agave-spirit-tx-fl
    Normal: /products/1777-spirit
     */

    // if in Shopify customizer, exit
    if (Shopify.designMode) {
        return;
    }

    // matrix of states
    const safetyStates = ["FL"];

    const normalStates = [
        "AK", "AL", "AR", "AZ", "CA",
        "CO", "CT", "DE", "GA", "HI",
        "IA", "ID", "IL", "IN", "KS",
        "KY", "LA", "MA", "MD", "ME",
        "MI", "MN", "MO", "MS", "MT",
        "NC", "ND", "NE", "NH", "NJ",
        "NM", "NV", "NY", "OH", "OK",
        "OR", "PA", "RI", "SC", "SD",
        "TN", "TX", "UT", "VA", "VT",
        "WA", "WI", "WV", "WY"
    ];

    // redirect based on state and current path
    if (safetyStates.includes(userSelectedState) && location.pathname === '/products/1777-spirit') {
        window.location.href = '/products/1777-thc-agave-spirit-tx-fl';
    } else if (normalStates.includes(userSelectedState) && location.pathname === '/products/1777-thc-agave-spirit-tx-fl') {
        window.location.href = '/products/1777-spirit';
    }
}

